import type { Overwrite } from "@mui/types";
import { META_ADS_CONFIG_ID } from "@polifonia/env";

import { fbSdk } from "@/lib/fbSdk";

type UseMetaAdsLoginOptions = Overwrite<
  NonNullable<Parameters<typeof fbSdk.hooks.mutations.useLoginMutation>[0]>,
  {
    onSuccess?: (data: {
      authResponse: {
        code: string;
      };
    }) => void;
  }
>;

/**
 * FBLB-based Meta Ads login. Uses the shared CAAC `fbSdk` and selects the
 * ads-to-chat permission scope via `META_ADS_CONFIG_ID` (the only piece
 * specific to ads), parallel to `useFacebookLogin` / `useWhatsappLogin`
 * picking their own FBLB config_ids on the same App.
 */
export function useMetaAdsLogin(options?: UseMetaAdsLoginOptions) {
  const loginMutation = fbSdk.hooks.mutations.useLoginMutation({
    ...options,
    onSuccess: async (data) => {
      if (data.status !== "connected" || !data.authResponse?.code) {
        return;
      }
      options?.onSuccess?.({
        authResponse: {
          code: data.authResponse.code,
        },
      });
    },
  });

  const startLogin = (loginOptions?: facebook.LoginOptions) => {
    loginMutation.mutate({
      loginOptions: {
        config_id: META_ADS_CONFIG_ID,
        response_type: "code",
        override_default_response_type: true,
        ...loginOptions,
      },
    });
  };

  return Object.assign(loginMutation, {
    startLogin,
  });
}
